var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.418 3H3V21H21.418V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34836 20.1026C4.14344 19.992 3.13525 19.0329 3 17.828V5.40997C3.11066 4.16817 4.04508 3.22145 5.27459 3.06161C8.11475 3.19686 11.127 2.86489 13.9426 3.06161C15.1967 3.14768 16.1926 4.0821 16.3402 5.32391V9.93456C15.7869 10.0329 15.2582 10.0821 14.7049 10.2543C11.0533 11.3977 9.29508 15.5903 11.0533 19.0206L11.7172 20.1026H5.34836ZM6.39344 6.73784C5.59426 6.86079 5.53279 7.88128 6.29508 8.1026L13.1557 8.06571C13.832 7.74604 13.6475 6.78702 12.8852 6.72555H6.39344V6.73784ZM6.39344 9.50423C5.59426 9.62719 5.53279 10.6477 6.29508 10.869L13.1557 10.8321C13.832 10.5125 13.6475 9.55342 12.8852 9.49194H6.39344V9.50423ZM6.39344 12.2584C5.61885 12.369 5.52049 13.3526 6.2582 13.6231H9.35656C10.1066 13.4264 10.0574 12.4059 9.29508 12.2706C8.81557 12.1846 6.88525 12.1846 6.39344 12.2706V12.2584Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1559 11.3606C20.1764 11.0286 22.8814 15.5286 20.5822 18.8974C18.5535 21.8729 14.0781 21.6761 12.3445 18.5163C10.6109 15.3565 12.701 11.6556 16.1559 11.3729V11.3606ZM16.451 13.7704C16.2297 13.8073 15.9592 14.0409 15.91 14.2622C15.8486 14.5696 15.8609 16.0696 15.91 16.4138C15.9838 17.0778 16.992 17.2007 17.2379 16.5368C17.3363 16.2663 17.324 14.8647 17.2994 14.5204C17.2625 14.0532 16.9674 13.6966 16.4633 13.7827L16.451 13.7704ZM16.5002 17.4343C15.615 17.5573 15.7256 18.9589 16.7461 18.7991C17.5453 18.6761 17.3609 17.3114 16.5002 17.4343Z",
    fill: "#FF9355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.fc51caef9df2ceb4c2ce3aec65812e3a.svg";
export { ForwardRef as ReactComponent };